<!-- Sidebar Navigation end-->
<!-- <div class="page-content" *ngIf="plan"> -->
<div class="page-content">
  <!-- Page Header-->
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">
        {{ (searches$ | async) ? 'Search Results' : 'Series' }}
      </h2>
    </div>
  </div>

  <section class="pt-20">
    <app-page-loader type="series" *ngIf="request.ref !== 'paginate' && (loading$ | async)"></app-page-loader>
    <div class="row" style="margin-bottom: 20px" *ngIf="!(loading$ | async)">
      <div class="col-md-4 col-8">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchString"
          placeholder="Search.."
          style="margin-top: 20px"
        />
      </div>
      <div class="col-md-2 col-4">
        <button class="btn btn-primary" style="margin-top: 20px" type="button" (click)="search()">Search</button>
        <ng-container *ngIf="searches$ | async">
          <button class="btn btn-primary" style="margin-top: 20px" type="button" (click)="reset()">Reset</button>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="(series$ | async) && !(searches$ | async)">
      <div fxLayout="row wrap" fxLayoutGap="16px">
        <div
          class="card"
          fxFlex="0 0 calc(25% - 16px)"
          fxFlex.md="calc(33% - 16px)"
          fxFlex.sm="calc(50% - 16px)"
          fxFlex.xs="calc(100% - 16px)"
          *ngFor="let item of series$ | async; let i = index"
        >
          <div class="video-item" [routerLink]="['/series/' + item.slug]">
            <img [src]="item.photo" class="cover" alt="" />
            <div #player_container></div>
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
              <div class="card-category">{{ item.videoCount }} Videos</div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="request.ref === 'paginate' && (loading$ | async)">
        Please wait. Loading series..
      </ng-container>
    </ng-container>

    <ng-container *ngIf="searches$ | async">
      <h2 *ngIf="series.length !== 0">Series</h2>
      <div fxLayout="row wrap" fxLayoutGap="16px" *ngIf="!(loading$ | async)">
        <div
          class="card"
          fxFlex="0 0 calc(25% - 16px)"
          fxFlex.md="calc(33% - 16px)"
          fxFlex.sm="calc(50% - 16px)"
          fxFlex.xs="calc(100% - 16px)"
          *ngFor="let item of series; let i = index"
        >
          <div class="video-item" [routerLink]="['/series/' + item.slug]">
            <img [src]="item.photo" class="cover" alt="" />
            <div #player_container></div>
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
              <div class="card-category">{{ item.videoCount }} Videos</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="searches$ | async">
      <h2 *ngIf="videos.length !== 0">Videos</h2>
      <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start start" class="mt-10 pt-2" id="videos-container">
        <div
          class="card"
          fxFlex="0 0 calc(25% - 16px)"
          fxFlex.md="calc(33% - 16px)"
          fxFlex.sm="calc(50% - 16px)"
          fxFlex.xs="calc(100% - 16px)"
          *ngFor="let item of videos; let i = index"
        >
          <div class="video-item">
            <ng-container *ngIf="item.type === 'PAID'">
              <ng-container *ngIf="item.type === 'PAID' && !planStatus(plan)">
                <div class="mask" [routerLink]="['/subscription']"></div>
                <img [src]="item.thumbnail" alt="" class="s-watch" />
                <div class="tag-watch">
                  Premium Access Only
                </div>
              </ng-container>
              <ng-container *ngIf="item.type === 'PAID' && planStatus(plan)">
                <ng-container *ngIf="item.isEmbed">
                  <div [innerHtml]="item.link | safe: 'html'"></div>
                </ng-container>
                <ng-container *ngIf="!item.isEmbed">
                  <div [innerHtml]="videoHtml(item.link)"></div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="item.type === 'FREE'">
              <ng-container *ngIf="item.isEmbed">
                <div [innerHtml]="item.link | safe: 'html'" class="external"></div>
              </ng-container>
              <ng-container *ngIf="!item.isEmbed">
                <div [innerHtml]="videoHtml(item.link)"></div>
              </ng-container>
            </ng-container>

            <div #player_container></div>
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
              <span class="card-category">{{ item.category.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="series.length === 0 && videos.length === 0 && !(loading$ | async)">
        No Results found
      </ng-container>
    </ng-container>
    <button
      type="button"
      [hidden]="true"
      id="openModalButton"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#exampleModal"
    >
      Launch demo modal
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Congratulations!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ modalText }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Watch Videos</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- <div class="page-content" *ngIf="!plan">
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">heyPogi New Website</h2>
    </div>
  </div>

  <section class="pt-20">
    <ng-container>
      <div class="page-header payment-header">
        <h1 align="center">
          Please Register a new account on the new heyPogi website
        </h1>
      </div>
      <div
        align="center"
        style="font-size: 30px;
      line-height: 1.2;
      margin-bottom: 30px;color:white"
      >
        Click here:
        <a
          href="https://heypogi.uscreen.io/"
          style="
    color: #fff;
    padding: 20px 30px;
    font-size: 20px;"
          >https://heypogi.uscreen.io/</a
        >
      </div>
    </ng-container>

    <div align="center"><img src="assets/images/logo1.png" width="170px" /></div>
  </section>
</div> -->
